export const PRODUCT_NAME = 'Atlas de Geometría Sagrada Aplicada al Cuerpo™'
export const PRICE = '$27.990 ARS'
export const PRICE_FULL = '$95.000 ARS'
export const MOCKUP_URL =
  'https://cdn.magicpatterns.com/uploads/bT8pNhG5jEZiy16AFr9hji/mockup_atlas_lumen_akasha.png'
export const MAIN_COVER_URL =
  'https://cdn.magicpatterns.com/uploads/bcsp2ZdEBsDDKAk5XfXJpD/Portada_ebook_principal_geometria_sagrada.png'

export type Stat = {
  value: string
  label: string
}

export const stats: Stat[] = [
  { value: '3', label: 'tomos' },
  { value: '150', label: 'páginas' },
  { value: '15+', label: 'protocolos' },
  { value: '7', label: 'pases' },
]

export type Volume = {
  number: string
  title: string
  description: string
  cover: string
}

export const volumes: Volume[] = [
  {
    number: 'Tomo I',
    title: 'Anatomía Sagrada y Puntos de Anclaje',
    description:
      'Aprendé a “ver” la estructura invisible. Los 5 sólidos platónicos en la anatomía, la proporción áurea humana, los 12 puntos de anclaje energético y el escaneo visual del campo áurico para un diagnóstico impecable.',
    cover:
      'https://cdn.magicpatterns.com/uploads/vJSydiPVxgX22nwZ128hfk/portada_tomo_1_geometria.png',
  },
  {
    number: 'Tomo II',
    title: 'Redes de Cristales y Rejillas Corporales',
    description:
      'La “farmacia geométrica”. Cómo construir la Flor de la Vida en el torso, el Cubo de Metatrón en la columna y triangulaciones de sanación. Protocolos para ansiedad, dolor crónico, insomnio y bloqueos emocionales.',
    cover:
      'https://cdn.magicpatterns.com/uploads/tiDe4JRZaLgcX4FFXcaGVC/Portada_tomo_2_geometria.png',
  },
  {
    number: 'Tomo III',
    title: 'Pases Energéticos y Geometría en Movimiento',
    description:
      'Tu cuerpo como instrumento. Los 7 pases esenciales (Trazo, Círculo, Espiral y más), la dinámica de espirales de transformación y el sellado maestro con Merkabah Corporal para que la sanación perdure.',
    cover:
      'https://cdn.magicpatterns.com/uploads/rNeRAHdm3SQkHAFoLavZJ7/Portada_tomo_3_geometria.png',
  },
]

export type Bonus = {
  n: string
  title: string
  description: string
  price: string
  cover: string
}

export const bonuses: Bonus[] = [
  {
    n: '01',
    title: 'Fichas Clínicas de Sesión Geometrizada',
    description:
      'Sistema de registro, diagnóstico y seguimiento profesional.',
    price: '$15.000',
    cover:
      'https://cdn.magicpatterns.com/uploads/k8N7B7hsZpTrtZAAfn3CzZ/Bono_1.png',
  },
  {
    n: '02',
    title: 'Guía de Piedras para Geometría Corporal',
    description:
      'Directorio práctico de cristales y su colocación según la necesidad.',
    price: '$15.000',
    cover:
      'https://cdn.magicpatterns.com/uploads/3bynNySVeEMcdiwHd4fnU5/Bono_2.png',
  },
  {
    n: '03',
    title: 'Masterclass: Los 3 Errores Geométricos',
    description:
      'Más la Guía de Frecuencias Solfeggio para potenciar tus pases.',
    price: '$12.000',
    cover:
      'https://cdn.magicpatterns.com/uploads/dGzrQG8ytuGUQuAokijJqZ/Bono_3.png',
  },
  {
    n: '04',
    title: 'Limpieza de Cristales por Forma',
    description:
      'Mantenimiento y recarga según la estructura del mineral.',
    price: '$12.000',
    cover:
      'https://cdn.magicpatterns.com/uploads/aNJiSWxBGXLUS5YPke3F2J/Bono_4.png',
  },
  {
    n: '05',
    title: 'Poster de Consultorio Digital HD',
    description:
      'Láminas de referencia rápida para imprimir y colgar en tu espacio.',
    price: '$12.000',
    cover:
      'https://cdn.magicpatterns.com/uploads/tuK1SdoU3Vpc3JZxTKeGYJ/Bono_5.png',
  },
  {
    n: '06',
    title: 'Directorio de Piedras Regionales Argentinas',
    description:
      'Ubicación, extracción y uso de minerales nativos de nuestra tierra.',
    price: '$10.000',
    cover:
      'https://cdn.magicpatterns.com/uploads/re4QujzHWTVEhhKbSNex84/Bono_6.png',
  },
]

export const BONUS_TOTAL = '$76.000 ARS'

export type Testimonial = {
  initials: string
  name: string
  location: string
  product: string
  text: string
}

export const featuredTestimonial: Testimonial = {
  initials: 'MG',
  name: 'María G.',
  location: 'Córdoba',
  product: 'Terapeuta Holística',
  text: 'Por primera vez tengo una herramienta visual que puedo abrir en consulta y mostrarle al paciente exactamente qué geometría vamos a trabajar y por qué. La autoridad que transmite es inmediata.',
}

export const testimonials: Testimonial[] = [
  {
    initials: 'JL',
    name: 'Julián L.',
    location: 'Buenos Aires',
    product: 'Especialista en Sanación Energética',
    text: 'El nivel de detalle técnico de cada protocolo es impresionante. Tiene la claridad de un material visual para mostrar al paciente y la profundidad técnica que exige un profesional.',
  },
  {
    initials: 'DL',
    name: 'Diego L.',
    location: 'Tucumán',
    product: 'Terapeuta Holístico',
    text: 'El bono de Piedras Argentinas me permitió conectar con la energía de mi tierra. Ahora mis pacientes valoran mucho más que use minerales locales con protocolos exactos.',
  },
]

export const painPoints: string[] = [
  'Perdés tiempo dudando qué cristal poner o qué movimiento hacer frente al paciente.',
  'Improvisás la sesión porque no tenés protocolos maestros organizados.',
  'Tus pacientes no visualizan lo que estás haciendo y les cuesta entender el proceso.',
  'Tus sesiones dependen de tu intuición del día, sin un sistema de respaldo preciso.',
  'No tenés herramientas visuales que eleven tu nivel de autoridad y profesionalismo.',
]

export type Faq = {
  q: string
  a: string
}

export const faqs: Faq[] = [
  {
    q: '¿Sirve si recién empiezo en terapias holísticas?',
    a: 'Sí, es ideal. Te da la estructura que la mayoría tarda años en construir. Cada protocolo te guía paso a paso: dónde mirar, qué poner y cómo mover la energía.',
  },
  {
    q: '¿Necesito tener todos los cristales mencionados?',
    a: 'No. El atlas te da opciones y equivalencias para que uses lo que tengas a mano, priorizando siempre la geometría por sobre el objeto.',
  },
]

export type Buyer = {
  name: string
  location: string
}

export const buyers: Buyer[] = [
  { name: 'María G.', location: 'Córdoba' },
  { name: 'Julián L.', location: 'Buenos Aires' },
  { name: 'Carolina P.', location: 'La Plata' },
  { name: 'Ricardo A.', location: 'Mendoza' },
  { name: 'Florencia B.', location: 'Rosario' },
  { name: 'Agustina S.', location: 'CABA' },
]
